import React from 'react';
import '../styles/components/gamecardskeleton.scss';

const GameCardSkeleton = () => {
    return (
        <div className="game-card-skeleton-wrapper">
            {Array.from({ length: 15 }).map((_, index) => (
                <div className="game-card-skeleton" key={index} />
            ))}
        </div>
    );
};

export default GameCardSkeleton;
